import {mapGetters} from 'vuex'
export const invoicesMixin = {
    computed: {
        ...mapGetters([
            'getInvoiceTypes',
            'account'
        ]),
    },
    methods: {
        normalizeInvoice: function (invoice) {
            // Primavera
            if(invoice.invoiceSystemType = 1){
                return{
                    bookingInvoiceLinkedId: invoice.bookingInvoiceLinkedId,
                    id: invoice.id,
                    bookingRelationsQuantity: invoice.bookingRelationsQuantity,
                    name: invoice.invoiceName? invoice.invoiceName : 'End costumer',
                    vatNr: invoice.invoiceTaxpayerNumber? invoice.invoiceTaxpayerNumber : '99999999',
                    systemType: invoice.invoiceSystemType,
                    targetType: invoice.targetType,
                    type: this.invoiceType(invoice.invoiceType),
                    date: invoice.date,
                    value: invoice.primaverA_TotalDocumento,
                    // code: invoice.primaverA_TipoDocumento+' '+invoice.primaverA_NumeroDocumento+ '/' + invoice.primaverA_Serie, // code wiht 'FA 150/W'
                    code: invoice.primaverA_NumeroDocumento+ '/' + invoice.primaverA_Serie, // code wiht '150/W'
                    originalObj: invoice
                }
            }
        },
        invoiceType: function(invoiceTypeId) {
            return this.getInvoiceTypes.filter(storedInvoiceType => {
                return storedInvoiceType.id == invoiceTypeId
            })[0]
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/invoices.js